// Feature help URL routes (will be appended to BRAND_URL)
const FEATURE_HELP_ROUTES = {
  agent_bots: '/hc/agent-bots',
  agents: '/hc/agents',
  audit_logs: '/hc/audit-logs',
  campaigns: '/hc/campaigns',
  canned_responses: '/hc/canned',
  channel_email: '/hc/email',
  channel_facebook: '/hc/fb',
  custom_attributes: '/hc/custom-attributes',
  dashboard_apps: '/hc/dashboard-apps',
  help_center: '/hc/help-center',
  inboxes: '/hc/inboxes',
  integrations: '/hc/integrations',
  labels: '/hc/labels',
  macros: '/hc/macros',
  message_reply_to: '/hc/reply-to',
  reports: '/hc/reports',
  sla: '/hc/sla',
  team_management: '/hc/teams',
  webhook: '/hc/webhooks',
  billing: '/pricing',
  saml: '/hc/saml',
  captain_billing: '/hc/captain_billing',
};

/**
 * Gets the base URL from global config (BRAND_URL)
 * Falls back to a default if not configured
 */
function getBrandUrl() {
  const brandUrl = window.globalConfig?.BRAND_URL || 'https://vagalume.digital';
  // Remove trailing slash if present
  return brandUrl.replace(/\/$/, '');
}

export function getHelpUrlForFeature(featureName) {
  const route = FEATURE_HELP_ROUTES[featureName];
  if (!route) return null;
  return `${getBrandUrl()}${route}`;
}
